export default {
	Role: {
		Admin: 'Quản trị',
		User: 'Người dùng'
	},
	TaxPaperFilterCode: {
		PaperPaymentCode: 'Số GNT',
		SubmissionId: 'Mã giao dịch',
		BankPaymentCode: 'Số chứng từ NH'
	},
	TaxPaperPayerName: {
		PayerTaxAgentName: 'Cơ quan thu',
		PayerBankName: 'Ngân hàng'
	},
	TaxPaperFilter: {
		PaperPaymentCode: 'Số GNT',
		SubmissionId: 'Mã giao dịch',
		BankPaymentCode: 'Số chứng từ NH',
		PayerTaxAgentName: 'Cơ quan thu',
		PayerBankName: 'Ngân hàng',
		Status: 'Trạng thái',
		FilingDate: 'Ngày nộp thuế',
		PaperCreatedDate: 'Ngày nộp GNT',
		PayerTaxAgentCode: 'Cơ quan thu',
		PayerBankCode: 'Ngân hàng'
	},
	NotificationFilter: {
		Date: 'Ngày nhận',
		Type: 'Loại dịch vụ',
		NotiAgency: 'Cơ quan thông báo'
	},
	Status: {
		All: 'Tất cả',
		SendToMisa: 'Đã gửi MISA',
		SendToTCT: 'Đã gửi TCT',
		TCTAccept: 'TCT chấp nhận',
		TCTReject: 'TCT không chấp nhận',
		Error: 'Gửi TCT thất bại'
	},

	/**
	 * Trạng thái giao dịch của khai thuế
	 */
	TaxReturnStatusEnum: {
		All: 'Tất cả',
		SendToMISA: 'Đã gửi MISA',
		SendToTCT: 'Đã gửi TCT',
		TCTReceive: 'TCT tiếp nhận',
		TCTNotReceive: 'TCT không tiếp nhận',
		TCTAccept: 'TCT chấp nhận',
		TCTReject: 'TCT không chấp nhận',
		Error: 'Gửi TCT thất bại',
		TCTProcessingRefund: 'Đang xử lý hoàn thuế',
		Cancel: 'Đã hủy hoàn thuế',
		RequestJustify: 'Yêu cầu GTBS hoàn thuế',
		Justified: 'Đã gửi GTBS hoàn thuế',
		Paused: 'Tạm dừng giải quyết hoàn thuế'
	},

	TaxReturnStatusEnum2: {
		All: 'Tất cả',
		SendToMISA: 'Đã gửi MISA',
		SendToTCT: 'Đã gửi TCT',
		TCTReceive: 'TCT tiếp nhận',
		TCTNotReceive: 'TCT không tiếp nhận',
		TCTAccept: 'TCT chấp nhận',
		TCTReject: 'TCT không chấp nhận',
		Error: 'Gửi TCT thất bại',
		TCTProcessingRefund: 'Đang xử lý hoàn thuế',
		Cancel: 'Đã hủy hoàn thuế',
		RequestJustify: 'Yêu cầu GTBS hoàn thuế',
		Justified: 'Đã gửi GTBS hoàn thuế',
		Paused: 'Tạm dừng giải quyết hoàn thuế'
	},

	/**
	 * Trạng thái giao dịch nộp thuế
	 */
	MTaxStatus: {
		Draft: 'Bản nháp',
		/// Gửi lên MISA
		SendToMISA: 'Đã gửi MISA',
		//Gửi lên TCT
		SendToTCT: 'Đã gửi TCT',
		//TCT đã duyệt
		TCTApproved: 'TCT chấp nhận',
		//TCT không duyệt
		TCTRejected: 'TCT không chấp nhận',
		// Gửi TCT thất bại
		SendToTCTError: 'Gửi TCT thất bại',
		// Ngân hàng đã duyệt
		BankApproved: 'Nộp thuế thành công',
		//Ngân hàng từ chối
		BankRejected: 'Nộp thuế không thành công'
	},

	/**
	 * Trạng thái của đăng kí dịch vụ
	 */
	MTaxStatusTextRegis: {
		/// Gửi lên MISA
		SendToMISA: 'Đã gửi MISA',
		//Gửi lên TCT
		SendToTCT: 'Đã gửi TCT',
		//TCT đã duyệt
		TCTApproved: 'TCT chấp nhận',
		//TCT không duyệt
		TCTRejected: 'TCT không chấp nhận',
		// Gửi TCT thất bại
		SendToTCTError: 'Gửi TCT thất bại',
		// Ngân hàng đã duyệt
		BankApproved: 'Thành công',
		//Ngân hàng từ chối
		BankRejected: 'Không thành công'
	},

	TaxPaperFilterDate: {
		PaperCreatedDate: 'Ngày nộp GNT',
		FilingDate: 'Ngày nộp thuế'
	},
	TypeOfMoney: {
		VND: 'VND',
		USD: 'USD'
	},
	TypeOrgAuthority: {
		StateAudit: 'Kiểm toán nhà nước',
		GovernmentInspector: 'Thanh tra chính phủ',
		FinancialInspector: 'Thanh tra tài chính',
		OtherCompetentAuthority: 'Cơ quan có thẩm quyền khác'
	},
	/**
	 * Cơ quan thông báo
	 */
	AgencyNoti: {
		AgencyTax: 'Cơ quan thuế',
		Bank: 'Ngân hàng'
	},

	/**
	 * Loại thông báo
	 */
	NotificationType: {
		RegisterService: 'Đăng ký dịch vụ',
		RegisterTax: 'Đăng ký thuế',
		Decleration: 'Khai thuế',
		PAYMENT: 'Nộp thuế',
		TaxRefund: 'Hoàn thuế'
	},

	/**
	 * Kết quả thông báo
	 */
	NotificationStatus: {
		TCTReceive: 'TCT tiếp nhận',
		TCTNotReceive: 'TCT không tiếp nhận',
		TCTAccept: 'TCT chấp nhận',
		TCTReject: 'TCT không chấp nhận',
		BankAccept: 'Nộp thuế thành công',
		BankReject: 'Nộp thuế không thành công'
	},

	/**
	 * Kết quả thông báo đăng ký dịch vụ
	 */
	NotificationStatusRegis: {
		TCTReceive: 'TCT tiếp nhận',
		TCTNotReceive: 'TCT không tiếp nhận',
		TCTAccept: 'TCT chấp nhận',
		TCTReject: 'TCT không chấp nhận',
		BankAccept: 'Thành công',
		BankReject: 'Không thành công'
	},

	/**
	 * Loại kỳ tính thế
	 */
	TypeTaxPeriod: {
		PeriodDate: 'Lần phát sinh',
		PeriodMonth: 'Tháng',
		PeriodQuarter: 'Quý',
		PeriodStage: 'Kỳ',
		PeriodYear: 'Năm',
		PeriodSetteYear: 'Quyết toán năm',
		PeriodSetteDate: 'Quyết định/thông báo'
	},
	Month: {
		Month1: 'Tháng 1',
		Month2: 'Tháng 2',
		Month3: 'Tháng 3',
		Month4: 'Tháng 4',
		Month5: 'Tháng 5',
		Month6: 'Tháng 6',
		Month7: 'Tháng 7',
		Month8: 'Tháng 8',
		Month9: 'Tháng 9',
		Month10: 'Tháng 10',
		Month11: 'Tháng 11',
		Month12: 'Tháng 12'
	},
	Quarter: {
		Quarter1: 'Quý I',
		Quarter2: 'Quý II',
		Quarter3: 'Quý III',
		Quarter4: 'Quý IV'
	},
	Stage: {
		Stage1: 'Kỳ 1',
		Stage2: 'Kỳ 2'
	},

	Authorized: {
		IsAuthorized: 'GNT nộp thay', //Giấy nộp tiền thay thế,
		NonAuthorized: 'GNT' //Giấy nộp tiền,
	},
	TaxReturnSubmissionFilterOptions: {
		TaxPeriod: 'Kỳ tính thuế',
		CreatedDate: 'Ngày gửi',
		Status: 'Trạng thái',
		DeclareSubmissionType: 'Loại tờ khai'
	},

	TaxReturnSubmissionIsPaidFilters: {
		Date: 'Ngày gửi tờ khai',
		TaxReturnParentCode: 'Loại thuế',
		IsOnlyViewTaxReturnHaveToPaidTax:
			'Chỉ xem những tờ khai có số thuế phải nộp'
	},

	/**
	 * Tình trạng nộp thuế của tờ khai
	 */
	TaxPaymentStatusEnum: {
		/// Không nộp thuế
		NOPAYTAX: 'Không nộp thuế',

		/// Chưa nộp thuế
		HAVENOTPAIDTAX: 'Chưa nộp thuế',

		/// Đã nộp một phần
		PAIDTAXAPART: 'Đã nộp một phần',

		/// Đã nộp thuế
		PAIDTAXFULL: 'Đã nộp thuế'
	},

	/**
	 * Loại kê khai: Tờ khai /Phụ lục
	 */
	TaxReturnTypeEnum: {
		PrimaryReport: 'Tờ khai',
		AdditionalReport: 'Phụ lục'
	},
	PeriodTypeEnum: {
		PeriodMonth: 'Tháng',
		PeriodQuarter: 'Quý',
		PeriodIncurred: 'Lần phát sinh',
		PeriodYear: 'Năm',
		SettlementYear: 'Quyết toán năm',
		PeriodStage: 'Kỳ'
	},

	Period: {
		ThisDay: 'Hôm nay',
		ThisWeek: 'Tuần này',
		FirstWeekToPresent: 'Đầu tuần tới hiện tại',
		ThisMonth: 'Tháng này',
		FirstMonthToPresent: 'Đầu tháng đến hiện tại',
		ThisQuarter: 'Quý này',
		FirstQuarterToPresent: 'Đầu quý đến hiện tại',
		ThisYear: 'Năm nay',
		FirstYearToPresent: 'Đầu năm đến hiện tại',
		SixFirstMonth: 'Sáu tháng đầu năm',
		SixLastMonth: 'Sáu tháng cuối năm',
		//Các tháng trong năm
		January: 'Tháng 1',
		February: 'Tháng 2',
		March: 'Tháng 3',
		April: 'Tháng 4',
		May: 'Tháng 5',
		June: 'Tháng 6',
		July: 'Tháng 7',
		August: 'Tháng 8',
		September: 'Tháng 9',
		October: 'Tháng 10',
		November: 'Tháng 11',
		December: 'Tháng 12',

		//Quý (DNThang sửa từ ký tự La mã về thành số nguyên)
		FiscalI: 'Quý 1', //Qúy 1
		FiscalII: 'Quý 2',
		FiscalIII: 'Quý 3',
		FiscalIV: 'Quý 4',

		Yesterday: 'Hôm qua',
		LastWeek: 'Tuần trước',
		LastMonth: 'Tháng trước',
		LastQuarter: 'Quý trước',
		LastYear: 'Năm trước',

		Tomorrow: 'Ngày mai',
		NextWeek: 'Tuần sau',
		NextMonth: 'Tháng sau',
		NextQuarter: 'Quý sau',
		NextYear: 'Năm sau',
		Custom: 'Tùy chọn'
	},
	SimplePeriod: {
		ThisDay: 'Hôm nay',
		ThisWeek: 'Tuần này',
		ThisMonth: 'Tháng này',
		ThisQuarter: 'Quý này',
		ThisYear: 'Năm nay',
		Yesterday: 'Hôm qua',
		LastWeek: 'Tuần trước',
		LastMonth: 'Tháng trước',
		FiscalI: 'Quý 1', //Qúy 1
		FiscalII: 'Quý 2',
		FiscalIII: 'Quý 3',
		FiscalIV: 'Quý 4',
		LastYear: 'Năm trước',
		Custom: 'Tùy chọn'
	},
	FinanceYearStartDateEnum: {
		FirstDayOfYear: '01/01',
		FirstDayOfTheFirstQuarter: '01/04',
		FirstDayOfTheSecondQuarter: '01/07',
		FirstDayOfTheThirdQuarter: '01/10'
	},

	TypeContactAddional: {
		TaxDec: 'Khai thuế',
		TaxPay: 'Nộp thuế',
		All: 'Tất cả'
	},
	SubmissionType: {
		/// Đăng ký sử dụng dịch vụ khai thuế TVAN
		Dec_RegistrationServiceTVAN: 'Đăng ký sử dụng dịch vụ khai thuế TVAN',
		/// Đăng ký ngừng sử dụng dịch vụ khai thuế TVAN
		Dec_StopServiceTVAN: 'Đăng ký ngừng sử dụng dịch vụ khai thuế TVAN',
		/// Đăng ký tờ khai nộp qua mạng
		Dec_RegistrationDeclare: 'Đăng ký tờ khai nộp qua mạng',
		/// Đăng ký ngừng nộp tờ khai qua mạng
		Dec_StopDeclare: 'Đăng ký ngừng nộp tờ khai qua mạng',
		/// Thay đổi, bổ sung thông tin dịch vụ khai thuế
		Dec_ChangeServiceTVAN: 'Thay đổi, bổ sung thông tin dịch vụ khai thuế',
		/// Đăng ký sử dụng dịch vụ nộp thuế TVAN
		Pay_RegistrationServiceTVAN: 'Đăng ký sử dụng dịch vụ nộp thuế TVAN',
		/// Đăng ký ngừng sử dụng dịch vụ nộp thuế TVAN
		Pay_StopServiceTVAN: 'Đăng ký ngừng sử dụng dịch vụ nộp thuế TVAN',
		/// Đăng ký thay đổi, bổ sung thông tin dịch vụ nộp thuế
		Pay_ChangeInfoService:
			'Đăng ký thay đổi, bổ sung thông tin dịch vụ nộp thuế',
		/// Đăng ký thay đổi, bổ sung thông tin ngân hàng dịch vụ nộp thuế
		Pay_ChangeBankService:
			'Đăng ký thay đổi, bổ sung thông tin ngân hàng dịch vụ nộp thuế',
		/// Ngừng ngân hàng
		Pay_StopBank: 'Ngừng ngân hàng',
		/// Giấy nộp tiền,
		Pay_TaxPaper: 'Giấy nộp tiền',
		/// Giấy nộp tiền nộp thay
		Pay_TaxPaperFiled: 'Giấy nộp tiền nộp thay',
		/// Nộp tờ khai thuế
		Dec_TaxReturn: 'Nộp tờ khai thuế',
		Dec_RegistrationDeclareHaunt: 'Đăng ký địa bàn vãng lai',
		Dec_StopDeclareHaunt: 'Đăng ký ngừng địa bàn vãng lai'
	},
	ContactType: {
		DECLERATION: 'Khai thuế',
		PAYMENT: 'Nộp thuế',
		ALL: 'Tất cả'
	},
	FormState: {
		/**
		 * Mode View
		 */
		View: 'Xem',
		/**
		 * Thêm
		 */
		Add: 'Thêm',
		/**
		 * Sửa
		 */
		Edit: 'Sửa',
		/**
		 * Nhân bản
		 */
		Duplicate: 'Nhân bản',
		/**
		 * Thêm nhanh
		 */
		QuickAdd: 'Thêm nhanh',
		// Thêm bản ghi với các bên tích hợp
		AddWidthData: 'Thêm với dữ liệu'
	},
	TypeTargetPayment: {
		Target7111: '7111',
		Target8993: '8993',
		Target3397: '3397',
	},

	EconomicCodePerson: {
		Code1001: '1001',
		Code1003: '1003',
		Code1004: '1004',
		Code1005: '1005',
		Code1006: '1006',
		Code1007: '1007',
		Code1008: '1008',
		Code1012: '1012',
		Code1014: '1014',
		Code1015: '1015',
		Code1049: '1049'
	},

	ChapterCodePerson: {
		Code557: '557',
		Code757: '757',
		Code857: '857'
	},

	ChapterLevel: {
		Center: 'Trung ương',
		Province: 'Tỉnh',
		District: 'Huyện',
		Ward: 'Xã'
	},

	/**
	 * Loại tờ khai: Lần đầu/ Bổ sung
	 */
	DeclareSubmissionType: {
		First: 'Lần đầu', //Lần đầu
		Additional: 'Bổ sung' //Bổ súng
	},
	PaymentStatus: {
		All: 'Tất cả',
		PaymentWait: 'Chưa thanh toán',
		PaymentSuccess: 'Đã thanh toán',
		PaymentCancel: 'Hủy đơn hàng'
	},
	PromotionCode: {
		/// <summary>
		/// Mã KM đã không hợp lệ
		/// </summary>
		Promotion_Invalid: 'Mã giảm giá không hợp lệ',

		/// <summary>
		/// Lỗi áp dụng 2 mã giảm giá khác loại
		/// </summary>
		Promotion_TypeOther:
			'Mã ##PromotionCode## giảm giá cho ##PromotionType##. Không áp dụng cùng lúc mã giảm giá cho cả đơn hàng và cho từng gói sản phẩm',

		/// <summary>
		/// Mã KM đã được sử dụng
		/// </summary>
		Promotion_Used: 'Mã giảm giá đã được sử dụng',

		/// <summary>
		/// Mã KM đã bị hủy
		/// </summary>
		Promotion_Destroyed: 'Mã giảm giá đã bị hủy',

		/// <summary>
		/// Mã KM đã hết hạn
		/// </summary>
		Promotion_Expired: 'Mã giảm giá đã hết hạn',

		/// <summary>
		/// Không đủ điều kiện áp dụng
		/// </summary>
		Promotion_NotEnough: 'Mã giảm giá không đủ điều kiện áp dụng',

		/// <summary>
		/// 1 gói sản phẩm chỉ được áp dụng 1 MGG
		/// </summary>
		Promotion_PackApplyCode:
			'Một gói sản phẩm chỉ được áp dụng 1 mã giảm giá',

		/// <summary>
		/// Lỗi khi update trạng thái mgg
		/// </summary>
		ValidateError: 108,

		/// <summary>
		/// Mã xác thực captcha không chính xác
		/// </summary>
		Captcha_Invalid: 'Mã xác thực captcha không chính xác',

		/// <summary>
		/// Lỗi exception không xử lí được thanh toán
		/// </summary>
		Exception: 'Lỗi không xử lí được thanh toán'
	},

	PaymentMethod: {
		Visa: 'VISA/MasterCard',
		ATM: 'ATM',
		PaymentProvider: 'Ví điện tử',
		Tranfers: 'Chuyển khoản',
		Paypal: 'Paypal',
		JeyPay: 'JetPay',
		Free: 'Miễn phí'
	},

	PaymentStatusEnum: {
		New: 'Chưa thanh toán', //Mới
		Wait: 'Chờ thanh toán', //
		Success: 'Đã thanh toán', //Đã thanh toán
		Cancel: 'Đã hủy đơn hàng' //Đã hủy
	},
	SoftwareEnum: {
		Mtax: 'MISA mTax',
		Esign: 'MISA Esign'
	},
	AccessLogFilter: {
		Date: 'Thời gian'
	},

	/**
	 * Thời gian khi xem dasboard số thuế đã nộp
	 */
	TimesTaxPaidEnum: {
		Full: 'Toàn thời gian',
		ThreeYear: '3 năm gần nhất',
		FiveYear: '5 năm gần nhất'
	},

	TaxTypeEnum: {
		VAT: 'Thuế giá trị gia tăng',
		Income: 'Thuế thu nhập doanh nghiệp',
		PersonalIncome: 'Thuế thu nhập cá nhân'
	},

	IsOnlyViewTaxReturnHaveToPaidTax: {
		isChecked: 'Chỉ xem những tờ khai có số thuế phải nộp'
	},
	ReasonType: {
		ProductNotGood: 'Sản phẩm không đáp ứng nhu cầu',
		ProductError: 'Sản phẩm hay bị lỗi',
		SupportServiceNotGood: 'Dịch vụ tư vấn hỗ trợ khách hàng kém',
		HighPrice: 'Giá thành cao',
		UseConvenient: 'Thao tác sử dụng không thuận tiện',
		SlowProcessingSpeed: 'Tốc độ xử lý chậm',
		SecurityNotGood: 'Bảo mật phần mềm kém',
		ReasonOther: 'Lý do khác'
	},
};
